module.exports = __webpack_public_path__ + "media/female_resultF.ee20a110.mp3";